import { jsx as _jsx } from "react/jsx-runtime";
import styles from './loader.module.scss';
const Loader = ({ isBackground, sm }) => {
    if (isBackground) {
        return (_jsx("div", Object.assign({ style: { zIndex: 5, backgroundColor: 'rgba(0,0,0,0.65)' }, className: "flex justify-content-center align-items-center vh-100 position-fixed w-100 top-0 bg-color-dark" }, { children: _jsx("div", { className: styles.spinner }) })));
    }
    if (sm) {
        return _jsx("div", { className: styles.spinnerSm });
    }
    return _jsx("div", { className: styles.spinner });
};
export default Loader;
